import { IconButton, Tooltip } from '@mui/material';

import QrScannerDialog from '@components/QrScannerDialog';
import { useNavigation } from '@hooks/useNavigation';
import { useQrScanner } from '@hooks/useQrScanner';
import { mailroomRoutes } from '@routes';

import { ScanQr } from '@src/assets/icons/ScanQr';
import { QR_CODE_PATTERN } from '@utils/qr';

export const ItemQrCodeScanner = () => {
  const { navigateWithPrevPath } = useNavigation();

  const { isOpen, openScanner, closeScanner, handleQrCodeRecognized } = useQrScanner({
    validationPattern: QR_CODE_PATTERN,
    onValidQrCode: (qrData: string) => {
      const pieceId = parseInt(qrData.replace('RD', ''), 10);

      if (isNaN(pieceId)) {
        return;
      }

      closeScanner();

      navigateWithPrevPath(mailroomRoutes.mailpiece('active/items', pieceId), {
        state: { previousCategory: 'active/items' },
      });
    },
  });

  return (
    <>
      <Tooltip title="Scan to find item">
        <IconButton onClick={openScanner}>
          <ScanQr />
        </IconButton>
      </Tooltip>

      <QrScannerDialog
        open={isOpen}
        title="Scan QR Code on Printed Label"
        onClose={closeScanner}
        onQrCodeRecognized={handleQrCodeRecognized}
      />
    </>
  );
};
